import { WiperWashAlertIcon } from './WiperWashAlertIcon';

/**
 * author: Michael Irigoyen
 * id 0BC113C0-8EC6-479E-86B6-A8F88C6B0371
 * name wiper-wash-alert
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wiper-wash-alert.svg
 * tags
 * - Alert / Error 
 * - Automotive 
 */
export const WiperFluidAlertIcon = WiperWashAlertIcon;
export default WiperFluidAlertIcon